import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ZonarUICoreModule } from '@zonar-ui/core';
import { ZonarUiProgressSpinnerModule } from '@zonar-ui/progress-spinner';
import { CoreModule } from 'src/app/modules/core/core.module';
import { ZonarUIMaterialModule } from '@zonar-ui/material';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { ActivityFeedComponent } from './components/activity-feed/activity-feed.component';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatChipsModule } from '@angular/material/chips';
import { HomePageComponent } from './pages/home/home.page.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { AuthModule } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';
import { ZonarUiI18nModule, TranslateModule } from '@zonar-ui/i18n';
import { ZonarUiFooterModule } from '@zonar-ui/footer';
import { SidenavModule } from '@zonar-ui/sidenav';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ZonarUiSearchableDropdownModule } from '@zonar-ui/searchable-dropdown';
import { DatadogService } from './services/datadog.service';
import { WithLoadingPipe } from '@shared/pipes/with-loading.pipe';
import { ENV, getEnv } from '@environments/environment.provider';
import { ZuiAssetNameComponent } from '@zonar-ui/asset-properties';
import { ZuiActivityFeedModule } from '@zonar-ui/activity-feed';
import { startupFactory } from './startup.factory';
import { PXInitService } from '@zonar-ui/auth';

@NgModule({
  declarations: [AppComponent, ActivityFeedComponent, HomePageComponent, WithLoadingPipe],
  imports: [
    AppRoutingModule,
    AuthModule.forRoot({
      clientId: environment.auth.clientID,
      domain: environment.auth.domain,
      audience: environment.auth.audience,
      redirect_uri: window.location.origin,
      scope: 'openid profile email',
      useRefreshTokens: true,
      max_age: 36000,
      cacheLocation: 'localstorage',
      httpInterceptor: {
        allowedList: [
          // `${environment.apiBase.url}/*`,
          `${environment.coreEntityApiBase.url}/*`,
          // `${environment.locationApi.url}/*`,
          // `${environment.pathApiBase.url}/*`,
          `${environment.apiBase}/*`,
          `${environment.userPreferenceApiBase.url}/*`,
          `${environment.reverseGeocoderApiBase}/*`,
          `${environment.coreEntityApiBase.url}beta2/*`,
          `${environment.eventSubscriptionApiBase}/*`,
          `${environment.locationApi.assetPropertiesUrl}/*`
        ]
      }
    }),
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    ZonarUICoreModule,
    FlexLayoutModule,
    ZonarUiProgressSpinnerModule,
    ZonarUiFooterModule,
    HttpClientModule,
    MatCardModule,
    MatGridListModule,
    MatDividerModule,
    MatListModule,
    MatButtonModule,
    MatBadgeModule,
    MatIconModule,
    MatChipsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTabsModule,
    ZonarUIMaterialModule,
    CdkAccordionModule,
    InfiniteScrollModule,
    AuthModule,
    SidenavModule.forRoot({ stage: environment.authEnv }),
    NgxSkeletonLoaderModule,
    ZuiActivityFeedModule,
    ZonarUiSearchableDropdownModule,
    ZonarUiI18nModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en-US'
    }),
    ZuiAssetNameComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: startupFactory,
      deps: [PXInitService],
      multi: true
    },
    { provide: 'applicationId', useValue: environment.auth.applicationId },
    {
      provide: 'supportedLanguages',
      useValue: environment.i18n.supportedLanguages
    },
    { provide: 'defaultLanguage', useValue: environment.i18n.defaultLanguage },
    DatadogService,
    { provide: ENV, useFactory: getEnv }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
